// extracted by mini-css-extract-plugin
module.exports = {"nudge":"ChatWidgetNudge_nudge__3jQNK","nudgeText":"ChatWidgetNudge_nudgeText__3o0rX","nudgeClose":"ChatWidgetNudge_nudgeClose__ryDMB"};